import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Link } from '@material-ui/core'
import styles from './NavHorizontal.module.css'

const NAV_ITEMS = [
    {
        label: 'SERVICES',
        href: '#my-work',
        children: [
            { label: 'GIS CONSULTING', url: '/consulting' },
            { label: 'ART TOURS', url: '/art-tours' },
        ],
    },
    { label: 'CONTACT', href: '#contact' },
];

const NavHorizontal = () => {
    let navigate = useNavigate()
    const [activeLang, setActiveLang] = useState('EN');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    // Handle sticky navbar background opacity on scroll
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
            <div className={styles.container}>

                {/* Brand Logo */}
                <a href="/" className={`logo ${styles.logo}` }>
                    <span className={styles.logoBold}>gabriel</span>
                    <span className={styles.logoDot}>.</span>
                    <span className={styles.logoLight}>aldana</span>
                </a>

                {/* Desktop Navigation */}
                <nav className={styles.desktopNav} aria-label="Main Navigation">
                    <ul className={styles.navList}>
                        {NAV_ITEMS.map((item) => (
                            <li
                                key={item.label}
                                className={styles.navItem}
                                onMouseEnter={() => item.children && setIsDropdownOpen(true)}
                                onMouseLeave={() => item.children && setIsDropdownOpen(false)}
                            >
                                <a href={item.href} className={styles.navLink}>
                                    {item.label}
                                    {item.children && <span className={styles.arrow}>▾</span>}
                                </a>

                                {/* Submenu / Dropdown */}
                                {item.children && (
                                    <ul
                                        className={`${styles.dropdown} ${
                                            isDropdownOpen ? styles.dropdownVisible : ''
                                        }`}
                                    >
                                        {item.children.map((child) => (
                                            <li key={child.label} className={styles.dropdownItem}>
                                                <Link to={ child.url } onClick={() => navigate(child.url)}>
                                                    <a className={styles.dropdownLink}>
                                                        {child.label}
                                                    </a>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>

                    {/* Language Switcher */}
                    {/*<div className={styles.langPicker}>*/}
                    {/*    <button*/}
                    {/*        className={`${styles.langBtn} ${activeLang === 'ES' ? styles.langActive : ''}`}*/}
                    {/*        onClick={() => setActiveLang('ES')}*/}
                    {/*    >*/}
                    {/*        Español*/}
                    {/*    </button>*/}
                    {/*    <span className={styles.langDivider}>|</span>*/}
                    {/*    <button*/}
                    {/*        className={`${styles.langBtn} ${activeLang === 'EN' ? styles.langActive : ''}`}*/}
                    {/*        onClick={() => setActiveLang('EN')}*/}
                    {/*    >*/}
                    {/*        English*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </nav>

                {/* Mobile Hamburger Button */}
                <button
                    className={styles.hamburger}
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label="Toggle Navigation Menu"
                    aria-expanded={isMobileMenuOpen}
                >
                    <span className={`${styles.bar} ${isMobileMenuOpen ? styles.barOpen : ''}`} />
                    <span className={`${styles.bar} ${isMobileMenuOpen ? styles.barOpen : ''}`} />
                    <span className={`${styles.bar} ${isMobileMenuOpen ? styles.barOpen : ''}`} />
                </button>
            </div>

            {/* Mobile Drawer Menu */}
            <div className={`${styles.mobileDrawer} ${isMobileMenuOpen ? styles.drawerOpen : ''}`}>
                <ul className={styles.mobileNavList}>
                    {NAV_ITEMS.map((item) => (
                        <li key={item.label} className={styles.mobileNavItem}>
                            <a
                                href={item.href}
                                className={styles.mobileNavLink}
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                {item.label}
                            </a>
                            {item.children && (
                                <ul className={styles.mobileSubList}>
                                    {item.children.map((child) => console.log(child) || (
                                        <li key={child.label}>
                                            <Link to={ child.url } onClick={() => navigate(child.url)}>
                                                <a
                                                    className={styles.mobileSubLink}
                                                >
                                                    {child.label}
                                                </a>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>

                {/* Mobile Language Selector */}
                <div className={styles.mobileLangPicker}>
                    <button
                        className={`${styles.langBtn} ${activeLang === 'ES' ? styles.langActive : ''}`}
                        onClick={() => setActiveLang('ES')}
                    >
                        Español
                    </button>
                    <span className={styles.langDivider}>|</span>
                    <button
                        className={`${styles.langBtn} ${activeLang === 'EN' ? styles.langActive : ''}`}
                        onClick={() => setActiveLang('EN')}
                    >
                        English
                    </button>
                </div>
            </div>
        </header>
    );
};

export default NavHorizontal;
